import classNames from "classnames";
import { FieldMessage, helpTextId } from "./FieldValue";
import { ReadOnlyFieldProps } from "./ReadOnlyField.types";

const EMPTY_VALUE_PLACEHOLDER = "—";

/** A field on a page the reader can't edit: its value as text, not a greyed control. */
export function ReadOnlyField({
  label,
  text,
  name,
  helpText,
  className = "",
}: ReadOnlyFieldProps) {
  return (
    <div className={classNames("field-value", className)}>
      <div className="field-value__label form-label">{label}</div>
      <div className="form-control-plaintext py-0 text-break white-space-pre-line">
        {text || EMPTY_VALUE_PLACEHOLDER}
      </div>
      {helpText && (
        <p
          id={helpTextId(name ?? "")}
          className="form-text small text-body-secondary mb-0"
        >
          {helpText}
        </p>
      )}
      <FieldMessage name={name ?? ""} />
    </div>
  );
}
